import { useRoleCan } from 'core/hooks/useRoleCan';
import { Capability } from 'core/roles';
import { getValidationRowUrl } from 'features/notifications/validations/validationNotifications';
import { ActivityRowLike, getActivityRowUrl } from '../utils/activityNavigation';

/**
 * Click target of an activity feed / notification row for the current session:
 * a validation entry opens the request (validator) or the quote contractualisation
 * (broker); any other entry follows getActivityRowUrl, gated by the matrix
 * (ActivityFeedLinks) like the segment links.
 */
export const useActivityRowUrl = (item: ActivityRowLike): string | null => {
  const canFollowLinks = useRoleCan(Capability.ActivityFeedLinks);
  const canOpenValidations = useRoleCan(Capability.ValidationsAccess);

  const validationUrl = getValidationRowUrl(item, { canOpenValidations, canFollowLinks });
  if (validationUrl) return validationUrl;

  return canFollowLinks ? getActivityRowUrl(item) : null;
};
